<app-dialog-basic [dialogTitle]="dialogTitle" [isLoading]="bookmarkProblemListDeleting">
  <div class="text-md mb-6">
    {{ data.listName }}
    を削除します。この操作はもとに戻せません。<br />
    共有している他の先生も見ることができなくなります。本当に削除してよろしいでしょうか。
  </div>

  <div class="progress-48">
    <mat-spinner [diameter]="48" @enter *ngIf="bookmarkProblemListDeleting"></mat-spinner>
  </div>

  <app-dialog-basic-footer>
    <div class="text-danger text-sm mr-auto" @enter *ngIf="errorMessage !== ''">{{ errorMessage }}</div>
    <button mat-stroked-button (click)="cancel()" [disabled]="bookmarkProblemListDeleting">キャンセル</button>
    <button mat-flat-button color="primary" (click)="deleteBookmarkProblemList()" [disabled]="bookmarkProblemListDeleting">
      削除
    </button>
  </app-dialog-basic-footer>
</app-dialog-basic>
